module.exports = __webpack_public_path__ + "img/section2.937b33df.png";